import MultiTourHandler from './MultiTourHandler';
export default (() => {
  const multiTourHandler = new MultiTourHandler();
  return {
    getInstance() {
      return multiTourHandler;
    }
  };
})();